import React from 'react'
import { format } from 'date-fns'

const Licenses = ({ appraiserInfo }) =>
  <div className='appraiser-licenses'>
    <h3>Licenses</h3>
    <table>
      <thead>
        <tr>
          <th>License Type</th>
          <th>License Number</th>
          <th>License Expiration Date</th>
          <th>License State</th>
        </tr>
      </thead>
      <tbody>
        {appraiserInfo.fetching && <tr><td>Loading...</td></tr>}
        {appraiserInfo && !appraiserInfo.error && !appraiserInfo.fetching
          && (appraiserInfo.licenses.length < 1 ?
            <tr><td colSpan='4'>No licenses found.</td></tr>
            : appraiserInfo.licenses.map(license =>
              <tr key={license.id}>
                <td>{license.appraiserLicenseType}</td>
                <td>{license.appraiserLicenseNumber}</td>
                <td>{format(license.appraiserLicenseExpirationDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</td>
                <td>{license.stateCode}</td>
              </tr>))}
        {appraiserInfo.error && <tr><td colSpan='4'>Error: Unable to load licenses.</td></tr>}
      </tbody>
    </table>
  </div>

export default Licenses
